module.exports = require("@bechtel/client-assets/dist/images/rod-room-inactive-icon.svg");